import { Inject, Injectable } from '@angular/core';
import { LoggerService } from './logger/logger.service';
import { ENVIRONMENT, WINDOW } from './injection-tokens';
import { Environment } from '../../../environments/environment.interface';
import { CoolHttp } from '@angular-cool/http';
import { Store } from '@ngxs/store';
import { HelpSiteService } from './help-site.service';
import { SetSiteDataAction } from '../../app.state';
import { Language } from '../../../../../common/dto/languages.dto';


@Injectable()
export class StartupService {
  constructor(
    private _loggerService: LoggerService,
    private _http: CoolHttp,
    private _store: Store,
    private _helpSiteService: HelpSiteService,
    @Inject(ENVIRONMENT) private _environment: Environment,
    @Inject(WINDOW) private _window: Window,
  ) {
  }

  public async setupAsync() {
    this._loggerService.initialize();

    this._setupHttp();

    //Do not wait for load
    this._loadSiteDataAsync();
  }

  private async _loadSiteDataAsync() {
    try {
      const helpSiteData = await this._helpSiteService.getHelpSiteDataAsync(this._getLanguage());

      this._store.dispatch(new SetSiteDataAction(helpSiteData));
    } catch (e: any) {
      this._loggerService.error(e);

      this._window.location.href = this._environment.helpSiteUrl;
    }
  }

  private _setupHttp() {
    this._http.registerBaseUrl(this._environment.serverUrl + '/api');
  }

  private _getLanguage(): Language {
    const url = new URL(this._window.location.href);

    return <Language>url.pathname.match(/^\/?([a-z]{2})(\/.*)?/)?.[1] ?? Language.English;
  }
}
